export const SPORTS_OVERLAYS_ID = 'sports-overlays';
export const SPORTS_SCRIPT_URL_TEMPLATE = 'SportsbookIntegrationURL';
